import React, { useState } from 'react';
import { Box, Typography, Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useAuth } from 'react-oidc-context';
import RMAFormModal from './RMAFormModal';

const RMANew = ({ onMessage, navigate, userType }) => {
  const auth = useAuth();
  const [modalIsOpen, setModalIsOpen] = useState(false);

  return (
    <>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          p: 4,
          height: '100%',
          minHeight: '200px',
          border: '2px dashed',
          borderColor: 'divider',
          borderRadius: 3,
          bgcolor: 'grey.50',
          textAlign: 'center',
          transition: 'all 0.2s ease-in-out',
          '&:hover': {
            borderColor: 'primary.main',
            bgcolor: 'primary.50',
          }
        }}
      >
        <Typography variant="h6" color="text.primary" fontWeight="bold" gutterBottom>
          {userType === 'serviceman' ? 'Create RMA for Customer' : 'Need to return a product?'}
        </Typography>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 3, maxWidth: '80%' }}>
          {userType === 'serviceman'
            ? 'Submit a Return Material Authorization request quickly on behalf of your customer.'
            : 'Submit a return material authorization request to get started.'}
        </Typography>

        <Button
          variant="contained"
          size="large"
          startIcon={<AddIcon />}
          onClick={() => setModalIsOpen(true)}
          sx={{
            borderRadius: 2,
            textTransform: 'none',
            fontWeight: 'bold',
            px: 4,
            py: 1.5,
            boxShadow: 2,
          }}
        >
          New RMA
        </Button>
      </Box>

      <RMAFormModal
        open={modalIsOpen}
        onClose={() => setModalIsOpen(false)}
        onMessage={onMessage}
        navigate={navigate}
        userType={userType}
        auth={auth}
      />
    </>
  );
};

export default RMANew;